import Router from 'lib/router';
import MobileToggle from 'lib/mobile-toggle';
import StockistsModal from 'lib/stockists';
import Navigation from 'lib/nav';
import Video from 'lib/video';

import routes from 'routes';


/**
 * Noisy May init class
 */
class NoisyMay {


    /**
     * Constructor
     */
    constructor () {
        this.router = new Router(routes);
        this.mobileToggle = new MobileToggle(document.querySelector('[data-nav-toggle="btn"]'), document.querySelector('[data-nav-toggle="container"]'));

        new Navigation(this.router);
        new StockistsModal(document.querySelector('.js-stockists'));
        new Video(document.querySelector('[data-player="container"]'));
    }
}

document.addEventListener('DOMContentLoaded', () => { new NoisyMay() });



// WEBPACK FOOTER //
// ./main.js